import { render, staticRenderFns } from "./bancoexamen.vue?vue&type=template&id=87b6659c&"
import script from "./bancoexamen.vue?vue&type=script&lang=js&"
export * from "./bancoexamen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports